import { render, staticRenderFns } from "./BookingCombineDetailPop.vue?vue&type=template&id=1ed32bbc"
import script from "./BookingCombineDetailPop.vue?vue&type=script&lang=js"
export * from "./BookingCombineDetailPop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/AzDevOps/myagent/_work/11/s/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1ed32bbc')) {
      api.createRecord('1ed32bbc', component.options)
    } else {
      api.reload('1ed32bbc', component.options)
    }
    module.hot.accept("./BookingCombineDetailPop.vue?vue&type=template&id=1ed32bbc", function () {
      api.rerender('1ed32bbc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/trans/popup/BookingCombineDetailPop.vue"
export default component.exports